import React from "react";
import './Terms.css';
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import { Container, Row, Col } from "react-bootstrap";
import icon1 from './assets/terms1.png';
import icon2 from './assets/terms2.png';
import icon3 from './assets/terms3.png';
import icon4 from './assets/terms4.png';
import icon5 from './assets/terms5.png';
import icon6 from './assets/terms6.png';
import icon7 from './assets/terms7.png';
import icon8 from './assets/terms8.png';
import icon9 from './assets/terms9.png';
import icon10 from './assets/terms10.png';

const Terms = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-12 middlecol">
                        <div className="row g-5 termscondition">
                            <div className="col-lg-12">
                                <h2>Terms and Conditions for customers purchasing from saad Motors Co LTD</h2>
                                <hr className="title-line"></hr>


                                <Row className="steps mt-4">
                                    <Col md={12} className="termsStep">
                                        <img src={icon1} alt="Car" className="icon" />
                                        <p>1. <b>Payment Methods:</b> All payments are to be made through Telegraphic Transfer (TT) or
                                            PayPal, in accordance with the regulations of the customer's country. The Proforma
                                            Invoice number must be referenced in the payment application.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon2} alt="Money" className="icon" />
                                        <p>2. <b>Payment Proof:</b> Customers must email proof of payment to saad Motors Co LTD, where it
                                            will be verified once funds are received.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon3} alt="Money" className="icon" />
                                        <p>3. <b>Reservation Period:</b> If payment is not made within seven working days or as agreed
                                            upon, the company reserves the right to sell the vehicle to another customer.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon4} alt="Money" className="icon" />
                                        <p>4. <b>Bank Charges: </b> Any charges from the issuing and correspondent banks are the
                                            responsibility of the customer.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon5} alt="Money" className="icon" />
                                        <p>5. <b>Estimated Shipment Date:</b> Shipment is expected within three weeks after the payment
                                            is confirmed.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon6} alt="Money" className="icon" />
                                        <p>6. <b>Amendments:</b> Any requests for changes to the Bill of Lading (BL) after shipment
                                            instructions are given will incur a USD 50 charge for each adjustment.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon7} alt="Money" className="icon" />
                                        <p>7. <b>Shipping Documents:</b> The original shipping documents for customs clearance will be
                                            sent to the customer upon full payment. If payment is delayed beyond the due date, the
                                            supplier has the right to cancel the deal.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon8} alt="Money" className="icon" />
                                        <p>8. <b>Payment Timeliness:</b> Customers must settle payments on time and are responsible for
                                            any delays or penalties resulting from late payments.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon9} alt="Money" className="icon" />
                                        <p>9. <b>Proof of Shipment:</b> Proof of shipment will be provided after the initial deposit. The
                                            Export & Inspection Certificate will only be sent after full payment.</p>
                                    </Col>
                                    <Col md={12} className="step">
                                        <img src={icon10} alt="Money" className="icon" />
                                        <p>10. <b>Full Payment Deadline:</b> Full payment must be received at least seven days before
                                            the ship's arrival at the designated port. If not, the supplier reserves the right to
                                            change the consignee to a local agent and charge a penalty to the original
                                            consignee.</p>
                                    </Col>
                                </Row>

                                <h3>This emphasizes the importance of timely payment and adherence to the
                                    specified terms to ensure smooth transactions.</h3>
                            </div>

                            <div className="col-lg-12 ceomessage">
                                <h2>Message from the CEO</h2>
                                <hr className="title-line"></hr>

                                <p>I hope this message finds you well. On behalf of saad Motors Co LTD. I would like to extend our
                                    gratitude for choosing us as your trusted partner in vehicle sourcing. We are committed to
                                    supporting your business by providing top-quality cars that meet the standards and preferences
                                    of your clients & also to the Individual Buyers.</p>

                                <p>As you know, our company has over 26 years of experience in the vehicle export industry,
                                    specializing in delivering only the best cars, trucks, and machinery, with a keen focus on quality
                                    control, competitive pricing, and seamless shipping.</p>

                                <p>We understand that your business at saad Motors Co LTD Vehicles Exporting Company requires
                                    vehicles that are reliable and cost-effective, and we are here to ensure your expectations are
                                    met and exceeded.</p>

                                <p>Warm regards, please feel free to reach out to us for any specific requirements or questions.</p>

                                <p>Our team is more than happy to assist you in selecting the right models and specifications
                                    tailored to your market needs.</p>

                                <p>Thank you once again for your partnership. We look forward to a prosperous business
                                    relationship and to helping saad Motors Co LTD Vehicles Exporting Company grow and thrive.</p>

                                <h4>CEO saad Motors Co LTD</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Terms;